export default __webpack_public_path__ + "static/NewLogo-240d54786524edbba38e4cf721bd0105.jpg";